import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Fade + rise on scroll into view
export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for headline text.
// lines: array of strings (or JSX). Each line is masked in an overflow-hidden container.
export function LineReveal({ lines, className = "", lineClassName = "", startDelay = 0.2 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: startDelay + i * 0.12 }}
            className={lineClassName}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
}
